import {OrderType} from '../../types/order.type';
import {Observable, throwError} from 'rxjs';
import {IResponse} from '@interfaces/response';
import {HttpClient} from '@angular/common/http';
import {ErrorService} from '@services/error/error.service';
import {createHttpParams} from '@shared/functions';
import {catchError, map, share} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {IAdvertiserBillingHoldsActive, IAdvertiserBillingHoldsHistory, IAdvertiserBillingOperations} from '@interfaces/advertiser/billing';
import {AdvertiserBillingHoldsSortType, AdvertiserBillingHoldsType} from '../../types/advertiser-billing-holds.type';
import {AdvertiserBillingOperationsSortType} from '../../types/advertiser-billing-operations.type';

@Injectable({
  providedIn: 'root'
})
export class AdvertiserBillingService {
  constructor(private http: HttpClient,
              private errorService: ErrorService) {
  }

  public getBillingOperations(
    {limit, skip = 0, search, sort, order}:
      {
        limit: number, skip: number, search: string,
        sort: AdvertiserBillingOperationsSortType;
        order: OrderType;
      }
  ): Observable<IResponse<IAdvertiserBillingOperations>> {
    const params = createHttpParams({
      limit, skip, sort, order, search
    });
    return this.http.get <IResponse<IAdvertiserBillingOperations>>('advertizer/billing/operations', {params}).pipe(
      catchError((err) => {
        this.errorService.showError(err);
        return throwError(err);
      })
    );
  }

  public getBillingHolds({limit, skip = 0, search, order, type, sort}: {
    limit: number, skip: number, search: string, sort: AdvertiserBillingHoldsSortType
    order: OrderType, type: AdvertiserBillingHoldsType
  }): Observable<IResponse<IAdvertiserBillingHoldsActive | IAdvertiserBillingHoldsHistory>> {
    const params = createHttpParams({
      limit, skip, order, search, sort
    });
    return this.http.get<IResponse<IAdvertiserBillingHoldsHistory | IAdvertiserBillingHoldsActive>>(`advertizer/billing/holds/${type}`,
      {params}).pipe(
      catchError((err) => {
        this.errorService.showError(err);
        return throwError(err);
      })
    );
  }

  public getAdvertiserBalance(): Observable<number> {
    return this.http.get<{balance: number}>('advertizer/billing/balance')
      .pipe(
        share(),
        catchError((err) => {
          this.errorService.showError(err);
          return throwError(err);
        }),
        map((res: {balance: number}) => {
          if (res.balance) return res.balance / 100;
          else return 0;
        })
      );
  }
}
